import { Helmet } from 'react-helmet-async';

/**
 * Per-page SEO tags (unique title + meta description).
 * The canonical link is handled globally by <RouteMeta /> in App.js
 * to guarantee a single canonical tag per route.
 * Usage: <SEO title="..." description="..." />
 */
export const SEO = ({ title, description }) => {
  const fullTitle = title ? `${title} | Y GO` : 'Y GO — VTC premium & transferts';
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default SEO;
